var render = function render(){var _vm=this,_c=_vm._self._c;return _c('hr',{class:`cv-toolbar-divider ${_vm.carbonPrefix}--toolbar-menu__divider`})
}
var staticRenderFns = []

export { render, staticRenderFns }